import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Button,
  Form,
} from "react-bootstrap";
import { ModernButton } from "./DefaultImports";
import { CustomModal } from "./CustomModal";
import { logout } from "../actions/userActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { getRestaurantSubscription } from "../actions/userActions";
import LogoImage from "../icons/logo.png";
import {
  fetchRestaurantList,
  fetchRestaurantDetails,
} from "../actions/restaurantActions";
import { getManager } from "../actions/managersActions";
import SuspensionAccountWarning from "./SuspensionAccountWarning";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import styled from "styled-components";
import {
  faSignOut,
  faBars,
  faUtensils,
  faCircleInfo,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import {
  CalendarSvgIcon,
  FilterSvgIcon,
  GearSvgIcon,
  NoPhoneSvgIcon,
  OnOffSvgIcon,
  PhoneSvgIcon,
  PlusSvgIcon,
  ReservationSvgIcon,
  TableSvgIcon,
  UsersSvgIcon,
  XSvgIcon,
  UserSvgIcon,
  ClockSvgIcon,
  BellSvgIcon,
  BubbleTextSvgIcon,
  ZoneSvgIcon,
  RestaurantIconSvg,
  InfoIconSvg,
  ChartSvgIcon,
} from "../icons/SvgIcons";
import { colors } from "@mui/material";
import SwitchOnAndOff from "./SwitchOnAndOff";
import { ConfirmationModal } from "./ConfirmationModal";
import LanguageSelector from "./LanguageSelector";
import { hasAgilFeatures, isCompletoTier } from "../utils/planFeatures";

// Change this if your plan-selection route is different.
const UPGRADE_PLAN_PATH = "/chooseplanandpay";
const Sidebar = styled.aside`
  position: relative;
  top: 0;
  left: 0;
  height: 100vh;
  width: ${({ $isCollapsed }) => ($isCollapsed ? "76px" : "252px")};
  background-color: #ffffff;
  border-right: 1px solid #efedeb;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  justify-content: space-between;
  transition: width 0.24s ease;

  @media (min-width: 769px) {
    overflow: visible;
  }

  @media (max-width: 768px) {
    position: fixed;
    height: 56px;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 6px 10px;
    border-right: 0;
    border-bottom: 1px solid #efedeb;
    box-shadow: 0 4px 18px rgba(42, 31, 33, 0.06);
    overflow: visible;
  }
`;
const HeaderTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 72px;
  margin-top: 18px;
  font-size: 2rem;
  color: #ff5733;
  font-weight: bold;

  @media (max-width: 768px) {
    width: auto;
    height: 40px;
    margin-top: 0;
    margin-left: 0;
  }
`;
const StyledDropdownButton = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  justify-content: ${({ $isCollapsed }) =>
    $isCollapsed ? "center" : "flex-start"};
  border: 1px solid ${({ $isOpen }) => ($isOpen ? "#ee754c" : "#ebe8e6")};
  border-radius: 12px;
  width: ${({ $isCollapsed }) => ($isCollapsed ? "40px" : "204px")};
  min-height: 40px;
  padding: 7px 10px;
  gap: ${({ $isCollapsed }) => ($isCollapsed ? "0" : "10px")};
  cursor: pointer;
  font-size: 0.82rem;
  font-weight: 600;
  color: ${({ $isOpen }) => ($isOpen ? "#ee754c" : "#4b3335")};
  margin: 0 0 0.4rem;
  background: ${({ $isOpen }) =>
    $isOpen ? "#fff5f0" : "#ffffff"};
  box-sizing: border-box;
  transition: all 0.2s ease;

  svg {
    stroke: ${({ $isOpen }) => ($isOpen ? "#ee754c" : "#4b3335")};
    min-width: 24px;
  }

  ${({ $isCollapsed }) =>
    $isCollapsed &&
    `
      padding-left: 0;
      padding-right: 0;
    `}

  @media (max-width: 768px) {
    margin-left: 0;
    width: 100%;
  }
`;
const Logo = styled.img`
  height: 58px;
  margin-right: 0;

  @media (max-width: 768px) {
    height: 38px;
    margin-right: 0;
  }
`;
const Menu = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: ${({ $isCollapsed }) =>
    $isCollapsed ? "center" : "flex-start"};
  justify-content: flex-start;
  gap: 4px;
  padding: ${({ $isCollapsed }) =>
    $isCollapsed ? "64px 0 16px" : "16px 24px"};
  flex: 1;
  width: 100%;

  @media (max-width: 768px) {
    justify-content: flex-start;
    margin-top: 0;
  }
`;
const RestaurantName = styled.nav`
  color: #4b3335;
  text-decoration: none;
  font-size: 1.2rem;
  font-weight: 500;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 1px;
  width: auto;
  gap: 10px;
  color: #ee754c;

  &.active {
    border-color: #ee754c;
    color: #ee754c;
    font-weight: bold;

    svg {
      stroke: #ee754c !important;
    }
  }

  &:hover {
    color: #ee754c;

    svg {
      stroke: #ee754c;
    }
  }

  @media (max-width: 768px) {
    margin-right: 20px;
  }
`;
const ShowBigScreen = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  @media (max-width: 768px) {
    display: none;
  }
`;
const MenuLink = styled(NavLink)`
  position: relative;
  color: #4b3335;
  text-decoration: none;
  min-height: 38px;
  font-size: 0.82rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  border: 0;
  border-radius: 12px;
  padding: 8px 10px;
  width: ${({ $isCollapsed }) => ($isCollapsed ? "40px" : "204px")};
  gap: ${({ $isCollapsed }) => ($isCollapsed ? "0" : "10px")};
  justify-content: ${({ $isCollapsed }) =>
    $isCollapsed ? "center" : "flex-start"};
  transition: color 0.16s ease, background-color 0.16s ease;
  margin-left: 0;

  &.active:not([data-menu-action="true"]) {
    color: #ee754c;
    font-weight: 700;
    background: #fff2ec;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 7px;
      bottom: 7px;
      width: 3px;
      border-radius: 0 4px 4px 0;
      background: #ee754c;
    }

    svg {
      stroke: #ee754c !important;
    }
  }

  &:hover {
    color: #ee754c;
    background: #fff7f3;

    svg {
      stroke: #ee754c;
    }
  }
`;
const Footer = styled.div`
  width: 100%;
  padding: ${({ $isCollapsed }) =>
    $isCollapsed ? "14px 0 18px" : "14px 24px 18px"};
  border-top: 1px solid #f2efed;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: ${({ $isCollapsed }) =>
    $isCollapsed ? "center" : "flex-start"};
  gap: 0.8rem;

  @media (max-width: 768px) {
    display: none;
  }
`;
const StyledButton = styled(Button)`
  background-color: #ff751a;
  border: none;
  font-size: 1rem;
  color: white;

  &:hover,
  &:focus,
  &:active {
    background-color: #e64a00 !important;
    border-color: #e64a00 !important;
  }
`;
const MobileMenuButton = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: grid;
    place-items: center;
    width: 36px;
    height: 36px;
    cursor: pointer;
    font-size: 1.25rem;
    color: #ff5733;
  }
`;
const MobileMenuContainer = styled.div`
  display: ${({ $show }) => ($show ? "flex" : "none")};
  flex-direction: column;
  background-color: #ffffff;
  position: absolute;
  top: 56px;
  left: 0;
  width: 100%;
  max-height: calc(100dvh - 56px);
  padding: 1rem;
  border-bottom: 1px solid #efedeb;
  box-shadow: 0 12px 28px rgba(42, 31, 33, 0.1);
  overflow-y: auto;

  @media (min-width: 768px) {
    display: none;
  }
`;
const Circle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ee754c;
  border-radius: 50%;
  width: 32px;
  height: 32px;
`;
const IconWrapper = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  min-width: 24px;
`;
const NotificationCountBadge = styled.span`
  position: absolute;
  top: -7px;
  right: -8px;
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  border-radius: 999px;
  background: #ee754c;
  color: white;
  font-size: 10px;
  font-weight: 800;
  line-height: 17px;
  text-align: center;
  box-sizing: border-box;
  pointer-events: none;
`;
const CollapseToggleButton = styled(Button)`
  position: absolute;
  top: 12px;
  right: ${({ $isCollapsed }) => ($isCollapsed ? "23px" : "16px")};
  z-index: 1500;
  width: 30px;
  height: 30px;
  min-height: 30px;
  padding: 0;
  border: 1px solid #ebe8e6;
  border-radius: 50%;
  background: #ffffff;
  color: #ee754c;
  box-shadow: none;

  @media (max-width: 768px) {
    display: none;
  }
`;
const DropdownWrapper = styled.div`
  position: relative;
  margin-left: 40px;
  margin-top: 50px;
  width: 200px;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 160px;
    min-width: 120px;
    margin: 0;
    margin-right: 30px;
  }
`;
const DropdownButton = styled.button`
  width: 100%;
  padding: 8px 12px;
  font-size: 0.8rem;
  font-weight: bold;
  color: #ee754c;
  background-color: #ffffff;
  border: 1px solid #ee754c;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(238, 116, 76, 0.4);
  }
`;
const DropdownList = styled.ul`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  background-color: #fff;
  border: 1px solid #e5e0d7;
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(75, 51, 53, 0.12);
  padding: 0.5rem 0;
  margin: 0;
  list-style: none;
  z-index: 1000;
  max-height: 250px;
  overflow-y: auto;
`;
const DropdownItem = styled.li`
  margin: 0 5px;
  padding: 10px 12px;
  font-size: 0.85rem;
  color: #99b0ad;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 8px;

  &:hover {
    background-color: #fff1e9;
    color: #ee754c;
  }

  &.active {
    font-weight: bold;
    color: #ee754c;
  }
`;
const SidebarLanguageSelector = styled(LanguageSelector)`
  width: ${({ $isCollapsed }) => ($isCollapsed ? "55px" : "fit-content")};
  display: flex !important;
  align-items: center;
  justify-content: ${({ $isCollapsed }) =>
    $isCollapsed ? "center" : "flex-start"};

  select {
    width: ${({ $isCollapsed }) => ($isCollapsed ? "55px" : "86px")};
    min-width: ${({ $isCollapsed }) => ($isCollapsed ? "55px" : "86px")};
    height: 34px;
    padding: ${({ $isCollapsed }) =>
      $isCollapsed ? "0 18px 0 8px" : "0 24px 0 34px"};
    color: #ee754c;
    background-color: #ffffff;
    font-size: ${({ $isCollapsed }) => ($isCollapsed ? "11px" : "13px")};
  }

  svg {
    display: ${({ $isCollapsed }) => ($isCollapsed ? "none" : "block")};
    left: 10px;
    font-size: 16px;
  }

  &::after {
    right: ${({ $isCollapsed }) => ($isCollapsed ? "8px" : "10px")};
  }

  @media (max-width: 768px) {
    width: fit-content;
    justify-content: flex-start;
    margin-top: 0.75rem;

    select {
      width: 86px;
      min-width: 86px;
      padding: 0 24px 0 34px;
      font-size: 13px;
    }

    svg {
      left: 10px;
      font-size: 16px;
    }
  }
`;
const RestaurantMenuLinks = ({
  restaurant_id,
  restaurants,
  list_of_restaurants,
  dispatch,
  managerInfo,
  setShowMenu,
  userInfo,
  setShowModal = false,
  isCollapsed = false,
  isMembersBlocked = false,
  isClientsBlocked = false,
}) => {
  const { t } = useTranslation();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [showClientsUpgradeModal, setShowClientsUpgradeModal] = useState(false);
  const navigate = useNavigate();

  const handleLinkClick = () => {
    setShowMenu(false);
  };
  const getLinkStyles = (condition) => ({
    pointerEvents: condition ? "none" : "auto",
    cursor: condition ? "default" : "pointer",
    color: condition ? "#858585" : "#4B3335",
  });
  const LockIcon = ({ condition }) =>
    condition ? (
      <FontAwesomeIcon
        icon={faLock}
        style={{
          color: "#858585",
          marginLeft: "20px",
        }}
      />
    ) : null;
  const RenderMenuRow = ({
    linkKey,
    to,
    label,
    Icon,
    disabled = false,
    lock = false,
    onBlockedClick = null,
    badge = 0,
    sectionStart = false,
  }) => (
    <div
      style={{
        display: "flex",
        justifyContent: isCollapsed ? "center" : "flex-start",
        width: "100%",
        marginBottom: "0.5rem",
        marginTop: sectionStart ? "0.75rem" : 0,
        paddingTop: sectionStart ? "0.75rem" : 0,
        borderTop: sectionStart ? "1px solid #f0edeb" : 0,
      }}
    >
      <MenuLink
        to={to}
        data-menu-action={linkKey === "sair" ? "true" : undefined}
        style={{
          ...getLinkStyles(disabled && !onBlockedClick),
          ...(onBlockedClick
            ? {
                color: "#858585",
                cursor: "pointer",
                opacity: 0.75,
              }
            : {}),
        }}
        $isCollapsed={isCollapsed}
        onClick={(event) => {
          if (onBlockedClick) {
            event.preventDefault();
            event.stopPropagation();
            onBlockedClick();
            return;
          }
          if (linkKey === "sair") {
            event.preventDefault();
            setShowModal(true);
            return;
          }
          handleLinkClick(linkKey);
        }}
      >
        <IconWrapper>
          <Icon
            width={isCollapsed ? 19 : 21}
            height={18}
            strokeColor={
              onBlockedClick
                ? "#858585"
                : "#4B3335"
            }
          />
          {Number(badge) > 0 && (
            <NotificationCountBadge>
              {Number(badge) > 99 ? "99+" : Number(badge)}
            </NotificationCountBadge>
          )}
        </IconWrapper>

        {!isCollapsed && (
          <>
            <span>{label}</span>

            {lock && (
              <FontAwesomeIcon
                icon={faLock}
                style={{
                  color: "#858585",
                  marginLeft: "auto",
                }}
              />
            )}
          </>
        )}
      </MenuLink>
    </div>
  );
  return (
    <div
      style={{
        textAlign: "start",
        width: "100%",
      }}
    >
      {list_of_restaurants && (
        <div
          style={{
            display: "flex",
            justifyContent: isCollapsed ? "center" : "flex-start",
            paddingLeft: 0,
            width: "100%",
          }}
        >
          <div
            style={{
              marginBottom: "0.5rem",
              width: isCollapsed ? "40px" : "204px",
            }}
          >
            <RestaurantSelectDropdown
              restaurants={list_of_restaurants}
              selectedId={restaurant_id}
              onChange={(id) => dispatch(fetchRestaurantDetails(id))}
              isCollapsed={isCollapsed}
            />
          </div>
        </div>
      )}

      {restaurant_id && (
        <>
          <RenderMenuRow
            linkKey="reservas"
            to={`reservationfromrestaurant/${restaurant_id}/null/filter`}
            label={t("ui.components.header.reservas")}
            Icon={ReservationSvgIcon}
          />

          <RenderMenuRow
            linkKey="estatisticas"
            to={`/statistics/${restaurant_id}`}
            label={t("ui.components.header.estatisticas")}
            Icon={ChartSvgIcon}
          />

          <RenderMenuRow
            linkKey="horarios"
            to={`/time/${restaurant_id}`}
            label={t("ui.components.header.horarios")}
            Icon={ClockSvgIcon}
            disabled={managerInfo && !managerInfo.edit_closed_days}
            lock={managerInfo && !managerInfo.edit_closed_days}
          />

          <RenderMenuRow
            linkKey="Não mexer"
            to={`/place_design/${restaurant_id}`}
            label={t("ui.components.header.salasEMesas")}
            Icon={ZoneSvgIcon}
            disabled={managerInfo && !managerInfo.edit_restaurant_settings}
            lock={managerInfo && !managerInfo.edit_restaurant_settings}
          />

          <RenderMenuRow
            linkKey="clientes"
            to={`/restaurantclients/${restaurant_id}`}
            label={t("ui.components.header.clientes")}
            Icon={UsersSvgIcon}
            lock={isClientsBlocked}
            onBlockedClick={
              isClientsBlocked ? () => setShowClientsUpgradeModal(true) : null
            }
          />

          <RenderMenuRow
            linkKey="notificacoes"
            to={`/restaurant_notifications/${restaurant_id}`}
            label={t("ui.components.header.notificacoes")}
            Icon={BellSvgIcon}
            disabled={managerInfo && !managerInfo.edit_restaurant_settings}
            lock={managerInfo && !managerInfo.edit_restaurant_settings}
          />

          <RenderMenuRow
            linkKey="definicoes"
            to={`/restaurantsettingsupdate/${restaurant_id}`}
            label={t("ui.components.header.definicoes")}
            Icon={GearSvgIcon}
            disabled={managerInfo && !managerInfo.edit_restaurant_settings}
            lock={managerInfo && !managerInfo.edit_restaurant_settings}
            sectionStart
          />

          <RenderMenuRow
            linkKey="info"
            to={`/restaurant_info_update/${restaurant_id}`}
            label={t("ui.components.header.informacoes")}
            Icon={InfoIconSvg}
            disabled={managerInfo && !managerInfo.edit_restaurant_settings}
            lock={managerInfo && !managerInfo.edit_restaurant_settings}
          />

          {!managerInfo && (
            <RenderMenuRow
              linkKey="colaboradores"
              to="/manager_account_creation"
              label={t("ui.components.header.membros")}
              Icon={UsersSvgIcon}
              lock={isMembersBlocked}
              onBlockedClick={
                isMembersBlocked ? () => setShowUpgradeModal(true) : null
              }
            />
          )}

          {setShowModal && (
            <>
              <RenderMenuRow
                linkKey="conta"
                to="/profile/update/no"
                label={t("ui.components.header.conta")}
                Icon={UserSvgIcon}
              />

              <RenderMenuRow
                linkKey="sair"
                to="#"
                label={t("ui.components.header.sair")}
                Icon={OnOffSvgIcon}
                disabled={false}
                lock={false}
              />
            </>
          )}
        </>
      )}

      {/* Members Upgrade Modal */}
      <CustomModal
        show={showUpgradeModal}
        onHide={() => setShowUpgradeModal(false)}
        title={t("ui.components.header.gestaoDeMembros")}
        body={
          <p
            style={{
              margin: 0,
            }}
          >
            {t("ui.components.header.aGestaoDeMembrosNaoEsta")}
          </p>
        }
        footer={
          <>
            <ModernButton
              color="#99b0ad"
              onClick={() => setShowUpgradeModal(false)}
            >
              {t("ui.components.header.agoraNao")}
            </ModernButton>

            <ModernButton
              color="#ee754c"
              onClick={() => {
                setShowUpgradeModal(false);
                setShowMenu(false);
                navigate(`/pick_plan_and_pay/${restaurants?.id}`);
              }}
            >
              {t("ui.components.header.verPlanos")}
            </ModernButton>
          </>
        }
      />

      {/* Clients Upgrade Modal */}
      <CustomModal
        show={showClientsUpgradeModal}
        onHide={() => setShowClientsUpgradeModal(false)}
        title={t("ui.components.header.gestaoDeClientes")}
        body={
          <p
            style={{
              margin: 0,
            }}
          >
            {t("ui.components.header.aGestaoDeClientesNaoEsta")}
          </p>
        }
        footer={
          <>
            <ModernButton
              color="#99b0ad"
              onClick={() => setShowClientsUpgradeModal(false)}
            >
              {t("ui.components.header.agoraNao2")}
            </ModernButton>

            <ModernButton
              color="#ee754c"
              onClick={() => {
                setShowClientsUpgradeModal(false);
                setShowMenu(false);
                navigate(`/pick_plan_and_pay/${restaurants?.id}`);
              }}
            >
              {t("ui.components.header.verPlanos2")}
            </ModernButton>
          </>
        }
      />
    </div>
  );
};
const RestaurantSelectDropdown = ({
  restaurants = [],
  selectedId,
  onChange,
  isCollapsed,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  const selectedRestaurant =
    restaurants.find((restaurant) => restaurant.id === selectedId) || {};
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div
      ref={wrapperRef}
      style={{
        position: "relative",
        width: "100%",
      }}
    >
      <StyledDropdownButton
        onClick={(event) => {
          event.preventDefault();
          setIsOpen((previousValue) => !previousValue);
        }}
        $isCollapsed={isCollapsed}
        $isOpen={isOpen}
      >
        <IconWrapper>
          <RestaurantIconSvg
            width={isCollapsed ? 19 : 21}
            height={18}
            strokeColor={isOpen ? "#ee754c" : "#4B3335"}
          />
        </IconWrapper>

        {!isCollapsed && (
          <>
            <span
              style={{
                display: "inline-block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {selectedRestaurant.restaurant_name?.length > 11
                ? `${selectedRestaurant.restaurant_name.substring(0, 11)}...`
                : selectedRestaurant.restaurant_name ||
                  t("ui.i18nFinalCleanup.selectRestaurant")}
            </span>

            <FontAwesomeIcon
              icon={isOpen ? faChevronUp : faChevronDown}
              style={{
                marginLeft: "auto",
              }}
            />
          </>
        )}
      </StyledDropdownButton>

      {isOpen && (
        <DropdownList
          style={{
            left: isCollapsed ? "52px" : "0",
            top: isCollapsed ? "0" : "calc(100% + 6px)",
            width: isCollapsed ? "200px" : "100%",
            zIndex: 1000,
          }}
        >
          <DropdownItem
            key="go-to-home"
            onClick={() => {
              setIsOpen(false);
              window.location.href = "/";
            }}
            style={{
              color: "#99b0ad",
              fontWeight: "bold",
            }}
          >
            {t("ui.components.header.restaurantes")}
          </DropdownItem>

          {restaurants.map((restaurant) => (
            <DropdownItem
              key={restaurant.id}
              onClick={() => {
                onChange(restaurant.id);
                setIsOpen(false);
              }}
              className={restaurant.id === selectedId ? "active" : ""}
            >
              {restaurant.restaurant_name}
            </DropdownItem>
          ))}
        </DropdownList>
      )}
    </div>
  );
};
function Header() {
  const { t } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  const [restaurant_id, setRestaurant_id] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMembersBlocked, setIsMembersBlocked] = useState(false);
  const [isClientsBlocked, setIsClientsBlocked] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const toggleMenu = () => {
    setShowMenu((previousValue) => !previousValue);
  };
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const manager_info = useSelector((state) => state.crudManager);
  const { managerInfo } = manager_info;
  const restaurant_sub = useSelector((state) => state.restaurant_subscription);
  const { restaurantSubscription } = restaurant_sub;
  const restaurantList = useSelector((state) => state.restaurantList);
  const { restaurants: list_of_restaurants, isLoading, error } = restaurantList;
  const restaurantDetails = useSelector((state) => state.restaurantDetails);
  const { restaurants } = restaurantDetails;
  const create_a_restaurant = useSelector((state) => state.create_a_restaurant);
  const { createRestaurant } = create_a_restaurant;
  const hash = window.location.hash;
  useEffect(() => {
    if (!userInfo?.token) {
      return;
    }
    dispatch(fetchRestaurantList());
  }, [dispatch, userInfo?.token, createRestaurant]);
  useEffect(() => {
    if (
      restaurantSubscription &&
      restaurantSubscription[0].account_type === "not_vip"
    ) {
      setShowHeader(false);
    } else {
      setShowHeader(true);
    }
  }, [restaurantSubscription]);
  useEffect(() => {
    dispatch(getRestaurantSubscription());
    dispatch(getManager());
  }, [dispatch]);
  useEffect(() => {
    if (restaurants) {
      setRestaurant_id(restaurants.id);
    }
    // Team members require an active Ágil-or-higher entitlement.
    setIsMembersBlocked(!hasAgilFeatures(restaurants));
    // Client profiles are Completo-only, monthly (3) or yearly (6).
    setIsClientsBlocked(!restaurants || !isCompletoTier(restaurants?.sub_lvl));
  }, [restaurants]);
  const logoutHandler = (event) => {
    event.preventDefault();
    dispatch(logout(navigate));
    setShowHeader(true);
  };
  useEffect(() => {
    console.log("restaurant_id: ", restaurant_id);
  }, [restaurant_id]);
  useEffect(() => {
    if (
      list_of_restaurants &&
      list_of_restaurants.length > 0 &&
      restaurant_id === false
    ) {
      const firstRestaurant = list_of_restaurants[0];
      const selectedId = firstRestaurant.id;
      setRestaurant_id(selectedId);
      console.log("selectedId: ", selectedId);
      dispatch(fetchRestaurantDetails(selectedId));
    }
  }, [dispatch, list_of_restaurants, restaurant_id]);
  return (
    <Sidebar $isCollapsed={isCollapsed}>
      <CollapseToggleButton
        variant="link"
        style={{
          color: "#EE754C",
          fontWeight: "bold",
        }}
        onClick={() => {
          setIsCollapsed((previousValue) => !previousValue);
        }}
        $isCollapsed={isCollapsed}
      >
        <FontAwesomeIcon
          style={{
            fontSize: "13px",
          }}
          icon={isCollapsed ? faChevronRight : faChevronLeft}
        />
      </CollapseToggleButton>

      {!isCollapsed && (
        <HeaderTitle onClick={() => navigate("/")}>
          <Logo
            src={LogoImage}
            alt={t("ui.components.header.logo")}
            style={{
              cursor: "pointer",
            }}
          />
        </HeaderTitle>
      )}

      <MobileMenuButton onClick={toggleMenu}>
        <FontAwesomeIcon icon={faBars} />
      </MobileMenuButton>

      <MobileMenuContainer $show={showMenu}>
        <Menu>
          <RestaurantSelectDropdown
            restaurants={list_of_restaurants}
            selectedId={restaurant_id}
            onChange={(id) => {
              dispatch(fetchRestaurantDetails(id));
            }}
            isCollapsed={false}
          />

          <RestaurantMenuLinks
            restaurant_id={restaurant_id}
            restaurants={restaurants}
            managerInfo={managerInfo}
            setShowMenu={setShowMenu}
            userInfo={userInfo}
            setShowModal={setShowModal}
            isMembersBlocked={isMembersBlocked}
            isClientsBlocked={isClientsBlocked}
          />

          <SidebarLanguageSelector />
        </Menu>
      </MobileMenuContainer>

      <ShowBigScreen>
        <Menu $isCollapsed={isCollapsed}>
          <RestaurantMenuLinks
            restaurant_id={restaurant_id}
            restaurants={restaurants}
            list_of_restaurants={list_of_restaurants}
            managerInfo={managerInfo}
            setShowMenu={setShowMenu}
            userInfo={userInfo}
            isCollapsed={isCollapsed}
            dispatch={dispatch}
            isMembersBlocked={isMembersBlocked}
            isClientsBlocked={isClientsBlocked}
          />
        </Menu>
      </ShowBigScreen>

      <ConfirmationModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onConfirm={logoutHandler}
        title={t("ui.components.header.sair2")}
        body={t("ui.i18nCleanup.logoutConfirm")}
        confirmLabel={t("ui.components.header.sair")}
        cancelLabel={t("common.cancel")}
        confirmColor="#ee754c"
        cancelColor="#99b0ad"
      />

      {!isCollapsed && (
        <Footer $isCollapsed={isCollapsed}>
          <SidebarLanguageSelector />

          <Link
            to="/profile/update/no"
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "#4b3335",
              fontWeight: "500",
            }}
          >
            <Circle
              style={{
                marginRight: "10px",
              }}
            >
              <UserSvgIcon strokeColor="#ffffff" width={18} height={18} />
            </Circle>
            {t("ui.components.header.conta2")}
          </Link>

          <div
            onClick={() => setShowModal(true)}
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              color: "#4b3335",
              fontWeight: "500",
            }}
          >
            <Circle
              style={{
                marginRight: "10px",
              }}
            >
              <OnOffSvgIcon strokeColor="#ffffff" width={18} height={18} />
            </Circle>
            {t("ui.components.header.sair3")}
          </div>
        </Footer>
      )}

      {isCollapsed && (
        <Footer $isCollapsed={isCollapsed}>
          <SidebarLanguageSelector $isCollapsed={isCollapsed} />

          <Link to="/profile/update/no">
            <Circle>
              <UserSvgIcon strokeColor="#ffffff" width={18} height={18} />
            </Circle>
          </Link>

          <div
            onClick={() => setShowModal(true)}
            style={{
              cursor: "pointer",
            }}
          >
            <Circle>
              <OnOffSvgIcon strokeColor="#ffffff" width={18} height={18} />
            </Circle>
          </div>
        </Footer>
      )}
    </Sidebar>
  );
}
export default React.memo(Header);
